<template>
  <div style="margin-top: 20px;">
    <h3>Clientes que confian en nosotros</h3>
    <div class="uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid="masonry: true">
      
      <div v-for="(item, key) in clientes.logos" :key="key">
          <div class="uk-card uk-card-default uk-flex uk-flex-center uk-flex-middle">
            <div class="uk-card-media-top">
              <img :src="api_url + item.image.formats.thumbnail.url" :alt="item.name">
            </div>
            <!-- {{item.image.formats.thumbnail.url}} -->
            <!-- {{item.name}} -->
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  data: function() {
    return {
      clientes: {},
      api_url: process.env.VUE_APP_STRAPI_API_URL
    };
  },
  props: {
    articles: Array
  },
  apollo: {
    clientes: {
      query: gql`
        query LOGOS{
          clientes: client{
            logos: logo{
              __typename
              ... on ComponentClientClient{
                name
                image{
                  formats
                }
              }
            }
          }
        }
      `
    }
  }
}
</script>

<style scoped>
  .logos-list{
    margin-top: 5rem;
  }
</style>